export const PROMPT_FIELD_NAMES = {
  END_OF_CONVERSATION_METADATA_EXTRACTOR:
    'end_of_conversation_metadata_extractor_prompt',
  CONVERSATION_METRICS: 'conversation_metrics_prompt',
  PII_MASKING: 'pii_masking_prompt',
  SYSTEM_PROMPT: 'system_prompt',
  INPROMPT_KNOWLEDGE_BASE: 'inprompt_knowledge_base',
  AGENT_OUTPUT_VALIDATOR_PROMPT: 'agent_output_validator_prompt',
} as const;

export const PROMPT_LABELS = {
  END_OF_CONVERSATION_METADATA_EXTRACTOR:
    'End of Conversation Metadata Extractor',
  CONVERSATION_METRICS: 'Conversation Metrics',
  PII_MASKING: 'PII Masking',
  SYSTEM_PROMPT: 'System Prompt',
  INPROMPT_KNOWLEDGE_BASE: 'Inprompt Knowledge Base',
  AGENT_OUTPUT_VALIDATOR_PROMPT: 'Agent Output Validator',
} as const;

export type PromptFieldConfig = {
  name: (typeof PROMPT_FIELD_NAMES)[keyof typeof PROMPT_FIELD_NAMES];
  label: string;
  hint?: string;
  hideModelFields?: boolean;
};

export const PROMPT_FIELDS: readonly PromptFieldConfig[] = [
  {
    name: PROMPT_FIELD_NAMES.END_OF_CONVERSATION_METADATA_EXTRACTOR,
    label: PROMPT_LABELS.END_OF_CONVERSATION_METADATA_EXTRACTOR,
  },
  {
    name: PROMPT_FIELD_NAMES.CONVERSATION_METRICS,
    label: PROMPT_LABELS.CONVERSATION_METRICS,
  },
  {
    name: PROMPT_FIELD_NAMES.PII_MASKING,
    label: PROMPT_LABELS.PII_MASKING,
  },
  {
    name: PROMPT_FIELD_NAMES.SYSTEM_PROMPT,
    label: PROMPT_LABELS.SYSTEM_PROMPT,
    hint: 'System Prompt LLM Model is defined on Agent Settings → Agent LLM → Primary LLM Model.',
    hideModelFields: true,
  },
  {
    name: PROMPT_FIELD_NAMES.INPROMPT_KNOWLEDGE_BASE,
    label: PROMPT_LABELS.INPROMPT_KNOWLEDGE_BASE,
    hint: 'The Inprompt Knowledge Base is injected into the System Prompt in place of the {RAG} variable.',
    hideModelFields: true,
  },
  {
    name: PROMPT_FIELD_NAMES.AGENT_OUTPUT_VALIDATOR_PROMPT,
    label: PROMPT_LABELS.AGENT_OUTPUT_VALIDATOR_PROMPT,
  },
] as const;
